import { Action } from '@ngrx/store';

//state
export interface MainState {
  isLoading: boolean;
  page: any;
}

export const MAIN_STATE_INIT: MainState = {
  isLoading: false,
  page: {},
}

//constants
export const MAIN_START_LOADING_ACTION = '[MAIN] START_LOADING_ACTION';
export const MAIN_STOP_LOADING_ACTION = '[MAIN] STOP_LOADING_ACTION';
export const MAIN_TOGGLE_LOADING_ACTION = '[MAIN] TOGGLE_LOADING_ACTION';
export const MAIN_SET_PAGE_ACTION = '[MAIN] SET_PAGE_ACTION';

//actions
export function mainStartLoadingAction(): Action {
  return { type: MAIN_START_LOADING_ACTION };
}
export function mainStopLoadingAction(): Action {
  return { type: MAIN_STOP_LOADING_ACTION };
}
export function mainToggleLoadingAction(): Action {
  return { type: MAIN_TOGGLE_LOADING_ACTION };
}
export function mainSetPageAction(payload: any): Action {
  return { type: MAIN_SET_PAGE_ACTION, payload };
}


//reducer
export function mainReducer(state: MainState = MAIN_STATE_INIT, action: Action): MainState {

  switch (action.type) {
    case MAIN_START_LOADING_ACTION:
      return Object.assign({}, state, { isLoading: true });
    case MAIN_STOP_LOADING_ACTION:
      return Object.assign({}, state, { isLoading: false });
    case MAIN_TOGGLE_LOADING_ACTION:
      return Object.assign({}, state, { isLoading: !state.isLoading });
    case MAIN_SET_PAGE_ACTION:
      return Object.assign({}, state, { page: action.payload });
    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/app/store/main/index.ts